import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { DateTime } from '../enum/date-time.enum';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);

export function formatDate(time: string): string {
  return dayjs(time).format(DateTime.DD_MM_YYYY);
}

export function formatTime(input: string | Date): string {
  if (input instanceof Date) {
    return dayjs(input).format(DateTime.HH_MM_SS);
  }
  if (typeof input === 'string' && input.includes('GMT')) {
    return dayjs(input).format(DateTime.HH_MM_SS);
  }
  return dayjs(input, [DateTime.TWELE_HOURS, DateTime.HH_MM_SS]).format(DateTime.HH_MM_SS);
}

export function formatToShortDate(dateInput: string | Date): string {
  const date = new Date(dateInput);
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
}

/**
 * Converts a given date/time value into a Unix timestamp in milliseconds.
 * Supports multiple input formats:
 * - number (assumed to already be a Unix timestamp in milliseconds)
 * - string (e.g., ISO date string)
 * - Date object (implicitly via Date parsing)
 * If the input is null, undefined, empty, or invalid, the function returns null.
 * @param value - The date/time value to convert (string, number, or Date-like value).
 * @returns The Unix timestamp in milliseconds, or null if the value is invalid or not provided.
 */
export function toUnixTime(value: any): number | null {
  if (value === null || value === undefined || value === '') {
    return null;
  }
  if (typeof value === 'number' && !Number.isNaN(value)) {
    return value;
  }
  const ms = new Date(value).getTime();
  return Number.isNaN(ms) ? null : ms;
}
